/**
 * Terms API client.
 */
import { apiGet, apiPost } from './client';
import type { TermsDto } from './types';

export const termsApi = {
  /**
   * Get current terms and conditions.
   */
  getCurrent: () => apiGet<TermsDto>('/terms/current'),

  /**
   * Get terms by version.
   */
  getByVersion: (version: string) => apiGet<TermsDto>(`/terms/${version}`),

  /**
   * Accept terms for an entry.
   */
  accept: (entryId: string, version: string) =>
    apiPost<void>(`/entries/${entryId}/terms`, { version }),
};
